import type { TutorBillingReturnStore } from './interfaces'

export const actions = {
  setReturnPath (this: TutorBillingReturnStore, payload: TutorBillingReturnStore['returnPath']): void { this.returnPath = payload },
}
